var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientplusprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_571_2817)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4556 87.8664C46.3154 87.955 45.163 88 44 88C42.837 88 41.6846 87.955 40.5444 87.8664L40.8062 84.492C41.8593 84.5738 42.9246 84.6155 44 84.6155C45.0754 84.6155 46.1407 84.5738 47.1938 84.492L47.4556 87.8664Z",
    fill: "url(#paint0_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.454 81.5345C30.4014 82.3421 32.425 83.0025 34.5113 83.5017L33.7238 86.7935C31.4621 86.2524 29.2685 85.5365 27.1576 84.6612L28.454 81.5345Z",
    fill: "url(#paint1_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8424 84.6612C58.7316 85.5365 56.5379 86.2524 54.2762 86.7935L53.4887 83.5017C55.575 83.0025 57.5986 82.3421 59.546 81.5345L60.8424 84.6612Z",
    fill: "url(#paint2_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6232 74.8858C19.2375 76.2658 20.9613 77.5214 22.7788 78.6375L21.0077 81.5218C19.0388 80.3127 17.1718 78.9529 15.4238 77.4586L17.6232 74.8858Z",
    fill: "url(#paint3_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5762 77.4586C70.8282 78.9529 68.9613 80.3127 66.9923 81.5218L65.2212 78.6375C67.0387 77.5214 68.7625 76.2658 70.3768 74.8858L72.5762 77.4586Z",
    fill: "url(#paint4_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36249 65.2212C10.4786 67.0387 11.7342 68.7625 13.1142 70.3768L10.5414 72.5762C9.04712 70.8282 7.68731 68.9613 6.47821 66.9923L9.36249 65.2212Z",
    fill: "url(#paint5_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5218 66.9923C80.3127 68.9613 78.9529 70.8282 77.4586 72.5762L74.8858 70.3768C76.2658 68.7625 77.5214 67.0387 78.6375 65.2212L81.5218 66.9923Z",
    fill: "url(#paint6_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49829 53.4887C4.99746 55.575 5.65792 57.5986 6.46545 59.546L3.33881 60.8424C2.46348 58.7316 1.74759 56.5379 1.20648 54.2762L4.49829 53.4887Z",
    fill: "url(#paint7_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7935 54.2762C86.2524 56.5379 85.5365 58.7316 84.6612 60.8424L81.5345 59.546C82.3421 57.5986 83.0025 55.575 83.5017 53.4887L86.7935 54.2762Z",
    fill: "url(#paint8_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32.1541C44.5854 32.1541 45.0855 32.3618 45.5005 32.7771C45.9156 33.1924 46.1235 33.6873 46.1236 34.2622V43.5596H55.431C56.0058 43.5596 56.501 43.7673 56.9161 44.1826C57.3312 44.5979 57.5385 45.0988 57.5385 45.6845C57.5385 46.27 57.331 46.7705 56.9161 47.1857C56.501 47.6011 56.0058 47.8088 55.431 47.8088H46.1236V57.1223C46.1236 57.6973 45.9156 58.1927 45.5005 58.608C45.0855 59.0232 44.5853 59.2311 44 59.2311C43.4147 59.2311 42.9145 59.0232 42.4995 58.608C42.0844 58.1927 41.8764 57.6973 41.8764 57.1223V47.8088H32.569C31.9943 47.8088 31.4996 47.601 31.0845 47.1857C30.6695 46.7704 30.4615 46.2702 30.4615 45.6845C30.4615 45.0988 30.6694 44.598 31.0845 44.1826C31.4996 43.7674 31.9943 43.5596 32.569 43.5596H41.8764V34.2622C41.8765 33.6873 42.0845 33.1924 42.4995 32.7771C42.9145 32.3618 43.4146 32.1541 44 32.1541Z",
    fill: "url(#paint9_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.508 40.8062C3.42618 41.8593 3.38446 42.9246 3.38446 44C3.38446 45.0754 3.42618 46.1407 3.508 47.1938L0.133606 47.4556C0.0450241 46.3154 0 45.163 0 44C4.23946e-08 42.837 0.0450239 41.6846 0.133606 40.5444L3.508 40.8062Z",
    fill: "url(#paint10_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8664 40.5444C87.955 41.6846 88 42.837 88 44C88 45.163 87.955 46.3154 87.8664 47.4556L84.492 47.1938C84.5738 46.1407 84.6155 45.0754 84.6155 44C84.6155 42.9246 84.5738 41.8593 84.492 40.8062L87.8664 40.5444Z",
    fill: "url(#paint11_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46545 28.454C5.65792 30.4014 4.99746 32.425 4.49829 34.5113L1.20648 33.7238C1.74759 31.4621 2.46348 29.2685 3.33881 27.1576L6.46545 28.454Z",
    fill: "url(#paint12_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6612 27.1576C85.5365 29.2685 86.2524 31.4621 86.7935 33.7238L83.5017 34.5113C83.0025 32.425 82.3421 30.4014 81.5345 28.454L84.6612 27.1576Z",
    fill: "url(#paint13_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1142 17.6232C11.7342 19.2375 10.4786 20.9613 9.36249 22.7788L6.47821 21.0077C7.68731 19.0388 9.04712 17.1718 10.5414 15.4238L13.1142 17.6232Z",
    fill: "url(#paint14_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4586 15.4238C78.9529 17.1718 80.3127 19.0387 81.5218 21.0077L78.6375 22.7788C77.5214 20.9613 76.2658 19.2375 74.8858 17.6232L77.4586 15.4238Z",
    fill: "url(#paint15_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7788 9.36249C20.9613 10.4786 19.2375 11.7342 17.6232 13.1142L15.4238 10.5414C17.1718 9.04712 19.0387 7.68731 21.0077 6.47821L22.7788 9.36249Z",
    fill: "url(#paint16_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9923 6.47821C68.9613 7.68731 70.8282 9.04712 72.5762 10.5414L70.3768 13.1142C68.7625 11.7342 67.0387 10.4786 65.2212 9.36249L66.9923 6.47821Z",
    fill: "url(#paint17_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5113 4.49829C32.425 4.99746 30.4014 5.65792 28.454 6.46545L27.1576 3.33881C29.2685 2.46348 31.4621 1.74759 33.7238 1.20648L34.5113 4.49829Z",
    fill: "url(#paint18_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2762 1.20648C56.5379 1.74759 58.7316 2.46348 60.8424 3.33881L59.546 6.46545C57.5986 5.65792 55.575 4.99746 53.4887 4.49829L54.2762 1.20648Z",
    fill: "url(#paint19_linear_571_2817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 0C45.163 0 46.3154 0.045024 47.4556 0.133606L47.1938 3.508C46.1407 3.42618 45.0754 3.38446 44 3.38446C42.9246 3.38446 41.8593 3.42618 40.8062 3.508L40.5444 0.133606C41.6846 0.0450242 42.837 4.23948e-08 44 0Z",
    fill: "url(#paint20_linear_571_2817)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_571_2817)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_571_2817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.0064,
    cy: 44,
    r: 40.48,
    fill: "#D6D6D6",
    fillOpacity: 0.32
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71,
    filter: "url(#filter2_f_571_2817)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint21_angular_571_2817_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0230606 -0.0250671 0.00938907 -0.00863752 64.3121 26.8889)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1079.37,
    y: -1079.37,
    width: 2158.74,
    height: 2158.74
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(148, 165, 249, 1) 0deg,rgba(92, 219, 246, 1) 108deg,rgba(255, 225, 117, 1) 180deg,rgba(214, 113, 246, 1) 288deg,rgba(159, 157, 249, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9836 60.5935C75.264 52.4332 76.948 32.2834 68.0093 22.5669C59.0706 12.8505 45.4146 11.6285 34.5342 8.00158C41.3196 1.75925 64.5114 8.262 73.4501 17.9785C82.3888 27.6949 84.7691 54.3512 77.9836 60.5935Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.58039218187332153,\"g\":0.64705884456634521,\"b\":0.97647058963775635,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.36078432202339172,\"g\":0.85882353782653809,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.30000001192092896},{\"color\":{\"r\":1.0,\"g\":0.88235294818878174,\"b\":0.45882353186607361,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.83921569585800171,\"g\":0.44313725829124451,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.80000001192092896},{\"color\":{\"r\":0.62352943420410156,\"g\":0.61568629741668701,\"b\":0.97647058963775635,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.58039218187332153,\"g\":0.64705884456634521,\"b\":0.97647058963775635,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.36078432202339172,\"g\":0.85882353782653809,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.30000001192092896},{\"color\":{\"r\":1.0,\"g\":0.88235294818878174,\"b\":0.45882353186607361,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.83921569585800171,\"g\":0.44313725829124451,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.80000001192092896},{\"color\":{\"r\":0.62352943420410156,\"g\":0.61568629741668701,\"b\":0.97647058963775635,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-46.121158599853516,\"m01\":18.778141021728516,\"m02\":77.9836425781250,\"m10\":-50.134143829345703,\"m11\":-17.275045394897461,\"m12\":60.593482971191406},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9836 60.5935C75.264 52.4332 76.948 32.2834 68.0093 22.5669C59.0706 12.8505 45.4146 11.6285 34.5342 8.00158C41.3196 1.75925 64.5114 8.262 73.4501 17.9785C82.3888 27.6949 84.7691 54.3512 77.9836 60.5935Z",
    fill: "url(#paint22_radial_571_2817)",
    fillOpacity: 0.88
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49,
    filter: "url(#filter3_f_571_2817)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint23_angular_571_2817_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0222324 0.0222324 -0.00694974 0.00694975 23.9019 66.1421)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1103.03,
    y: -1103.03,
    width: 2206.05,
    height: 2206.05
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(148, 165, 249, 1) 0deg,rgba(92, 219, 246, 1) 108deg,rgba(255, 225, 117, 1) 180deg,rgba(214, 113, 246, 1) 288deg,rgba(159, 157, 249, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16039 40.4189C8.90831 47.7681 10.1673 59.7897 19.503 69.1254C28.8386 78.461 43.1504 77.1658 53.0841 81.4248C45.9554 84.9891 25.8856 81.8495 16.5499 72.5139C10.2722 67.9137 2.89905 49.9332 5.16039 40.4189Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.58039218187332153,\"g\":0.64705884456634521,\"b\":0.97647058963775635,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.36078432202339172,\"g\":0.85882353782653809,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.30000001192092896},{\"color\":{\"r\":1.0,\"g\":0.88235294818878174,\"b\":0.45882353186607361,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.83921569585800171,\"g\":0.44313725829124451,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.80000001192092896},{\"color\":{\"r\":0.62352943420410156,\"g\":0.61568629741668701,\"b\":0.97647058963775635,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.58039218187332153,\"g\":0.64705884456634521,\"b\":0.97647058963775635,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.36078432202339172,\"g\":0.85882353782653809,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.30000001192092896},{\"color\":{\"r\":1.0,\"g\":0.88235294818878174,\"b\":0.45882353186607361,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.83921569585800171,\"g\":0.44313725829124451,\"b\":0.96470588445663452,\"a\":1.0},\"position\":0.80000001192092896},{\"color\":{\"r\":0.62352943420410156,\"g\":0.61568629741668701,\"b\":0.97647058963775635,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":44.464786529541016,\"m01\":-13.899489402770996,\"m02\":8.6192750930786133,\"m10\":44.464778900146484,\"m11\":13.899492263793945,\"m12\":36.960010528564453},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16039 40.4189C8.90831 47.7681 10.1673 59.7897 19.503 69.1254C28.8386 78.461 43.1504 77.1658 53.0841 81.4248C45.9554 84.9891 25.8856 81.8495 16.5499 72.5139C10.2722 67.9137 2.89905 49.9332 5.16039 40.4189Z",
    fill: "url(#paint24_radial_571_2817)",
    fillOpacity: 0.88
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1485 65.1623C12.7436 57.0625 38.988 65.6295 53.4166 57.7829C67.8452 49.9363 74.1617 28.1873 78.5666 36.2871C82.9715 44.3868 71.4383 69.111 57.0098 76.9576C42.5811 84.8042 21.5534 73.2621 17.1485 65.1623Z",
    fill: "url(#paint25_radial_571_2817)",
    fillOpacity: 0.91
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.887 77.7533C42.4908 75.7735 48.2187 75.7544 52.2893 74.9399C56.3599 74.1253 60.7377 71.1903 61.1339 73.1701C61.53 75.1499 56.8282 78.3813 52.7576 79.1958C48.687 80.0104 43.2831 79.7331 42.887 77.7533Z",
    fill: "url(#paint26_radial_571_2817)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6646 40.4357C73.6902 40.8584 74.0687 37.3474 73.55 34.9249C73.0314 32.5024 70.4488 30.0841 72.4231 29.6614C74.3974 29.2387 77.249 31.8288 77.7676 34.2513C78.2863 36.6737 77.6389 40.013 75.6646 40.4357Z",
    fill: "url(#paint27_radial_571_2817)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3725 17.1155C25.8002 18.5432 22.6471 20.1334 20.8954 21.8852C19.1436 23.6369 18.5169 27.1191 17.0892 25.6914C15.6615 24.2637 16.2863 20.4624 18.0381 18.7107C19.7898 16.9589 22.9448 15.6878 24.3725 17.1155Z",
    fill: "url(#paint28_radial_571_2817)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_571_2817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.2259,
    cy: 55.9696,
    r: 16.3206,
    fill: "url(#paint29_linear_571_2817)",
    fillOpacity: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_571_2817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.0298,
    cy: 37.8354,
    r: 16.3207,
    transform: "rotate(150 28.0298 37.8354)",
    fill: "url(#paint30_linear_571_2817)",
    fillOpacity: 0.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3912 69.0135C56.995 67.0336 60.5007 67.4592 62.9299 66.9731C65.3591 66.487 67.8119 63.9371 68.2081 65.917C68.6042 67.8968 65.976 70.7133 63.5468 71.1994C61.1176 71.6854 57.7873 70.9933 57.3912 69.0135Z",
    fill: "url(#paint31_radial_571_2817)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5663 16.2996C76.2502 24.7517 53.246 22.9099 38.1898 29.4722C23.1336 36.0345 11.0457 64.2186 7.36181 55.7664C3.67794 47.3143 17.3172 23.6867 32.3735 17.1244C47.4297 10.5621 68.8824 7.84751 72.5663 16.2996Z",
    fill: "url(#paint32_radial_571_2817)",
    fillOpacity: 0.71
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_571_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1123 16.1423C53.07 20.6341 42.3446 22.3833 35.214 25.4912C28.0833 28.5991 21.6783 36.7358 19.7206 32.244C17.7628 27.7522 24.5933 18.8291 31.7239 15.7212C38.8546 12.6133 49.1545 11.6506 51.1123 16.1423Z",
    fill: "url(#paint33_radial_571_2817)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_571_2817",
    x: -4.25,
    y: -3.1875,
    width: 96.5,
    height: 96.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.0625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_571_2817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_571_2817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_571_2817",
    x: 3.52637,
    y: 3.51999,
    width: 88.6226,
    height: 88.6226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.95628,
    dy: 12.9369
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.8313
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_571_2817"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.98057,
    dy: 2.98543
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.99029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_571_2817",
    result: "effect2_innerShadow_571_2817"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.995143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64199
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_571_2817",
    result: "effect3_innerShadow_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_571_2817",
    x: 32.0027,
    y: 3.01332,
    width: 52.4243,
    height: 60.1116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26574,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint21_angular_571_2817_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9836 60.5935C75.264 52.4332 76.948 32.2834 68.0093 22.5669C59.0706 12.8505 45.4146 11.6285 34.5342 8.00158C41.3196 1.75925 64.5114 8.262 73.4501 17.9785C82.3888 27.6949 84.7691 54.3512 77.9836 60.5935Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_571_2817",
    x: 2.9205,
    y: 38.5962,
    width: 51.9861,
    height: 46.0822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.911331,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint23_angular_571_2817_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16039 40.4189C8.90831 47.7681 10.1673 59.7897 19.503 69.1254C28.8386 78.461 43.1504 77.1658 53.0841 81.4248C45.9554 84.9891 25.8856 81.8495 16.5499 72.5139C10.2722 67.9137 2.89905 49.9332 5.16039 40.4189Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_571_2817",
    x: 12.4034,
    y: 30.2559,
    width: 71.3671,
    height: 53.5705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.12644,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_571_2817",
    x: 42.2596,
    y: 71.8889,
    width: 19.5051,
    height: 8.34264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.303777,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_571_2817",
    x: 71.0829,
    y: 29.0082,
    width: 7.46316,
    height: 12.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.303777,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_571_2817",
    x: 15.6923,
    y: 15.8918,
    width: 9.6487,
    height: 10.7427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.303777,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_571_2817",
    x: 34.7537,
    y: 35.4974,
    width: 40.9448,
    height: 40.9445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.07581,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_571_2817",
    x: 7.65569,
    y: 17.4617,
    width: 40.7482,
    height: 40.7475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02518,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_571_2817",
    x: 56.7528,
    y: 64.5666,
    width: 12.1028,
    height: 7.38981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.303777,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_571_2817",
    x: 2.50103,
    y: 6.75196,
    width: 74.7118,
    height: 54.8344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.12644,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_571_2817",
    x: 18.267,
    y: 11.9644,
    width: 34.1935,
    height: 22.7161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.556925,
    result: "effect1_foregroundBlur_571_2817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_571_2817",
    x1: 0,
    y1: 0,
    x2: 88.7174,
    y2: 0.729297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3121 26.8889) rotate(137.387) scale(12.7578 34.061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9019 66.1421) rotate(-45) scale(9.82842 31.4413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8116 71.0119) rotate(-118.538) scale(16.6942 29.7398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4686 75.836) rotate(-101.315) scale(3.65585 7.51659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.4437 34.7335) rotate(167.915) scale(3.65585 4.48568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2491 21.2389) rotate(45) scale(3.65585 4.48568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_571_2817",
    x1: 44.3455,
    y1: 43.7291,
    x2: 76.9868,
    y2: 66.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCABD2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCABD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_571_2817",
    x1: 17.1494,
    y1: 25.595,
    x2: 49.7907,
    y2: 48.7159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCABD2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCABD2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.1092 67.8693) rotate(-101.315) scale(3.65585 4.48567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0312 23.5865) rotate(66.4499) scale(16.6942 29.7399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_571_2817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3278 23.4579) rotate(66.4499) scale(8.87202 14.0842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_2817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_571_2817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientplusprofile);
export default __webpack_public_path__ + "static/media/gradient.plus.profile.f8ea89ac792cdbaf337adf16f6d31b78.svg";
export { ForwardRef as ReactComponent };